import { MoonLoader } from "react-spinners"

const LoadingSpinner = () => {
  return (
    <div className="d-flex justify-content-center align-items-center loading-spinner" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 9999
    }}>
      <MoonLoader
        color="#4facfe"
        loading
        size={80}
        speedMultiplier={1}
      />
    </div>
  )
}

export default LoadingSpinner